import { render } from "./Beneficiarios.vue?vue&type=template&id=9ac1f0e2"
import script from "./Beneficiarios.vue?vue&type=script&lang=js"
export * from "./Beneficiarios.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__